/** 32-hex-char ids, like Notion's page ids. Uses Web Crypto (available in browsers and Node ≥ 19). */
export function newId(): string {
  return globalThis.crypto.randomUUID().replaceAll('-', '');
}

/** Short ids for non-page entities (properties, views, options). */
export function shortId(len = 8): string {
  const bytes = new Uint8Array(len);
  globalThis.crypto.getRandomValues(bytes);
  const alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789';
  return Array.from(bytes, (b) => alphabet[b % alphabet.length]).join('');
}
